import React, { useState } from "react";
import {
  Form,
  Input,
  Button,
  Select,
  Checkbox,
  message,
  Row,
  Col,
  Radio,
} from "antd";
import styles from "./OtherPages.module.css";
import { getTranslation } from "../../util/utilFunc";
import { useSelector } from "react-redux";
import ProjectServices from "../../services/projectServices";
import { FiCheckCircle } from "react-icons/fi";
import { Link } from "react-router-dom";

const { Option } = Select;

const EarlyAccess = () => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const { language } = useSelector((state) => state.auth);
  const [selectedIndustry, setSelectedIndustry] = useState("");
  const [showOtherInput, setShowOtherInput] = useState(false);
  const [isBudgetHolder, setIsBudgetHolder] = useState("");
  const [isInviting, setIsInviting] = useState("");
  const [isUsingTools, setIsUsingTools] = useState("");
  const [selectedFeatures, setSelectedFeatures] = useState([]);
  const [isAccepted, setIsAccepted] = useState(false);
  const handleCheckboxChange = (checkedValues) => {
    setSelectedFeatures(checkedValues);
  };

  const goalsOptions = [
    getTranslation("Build a culture that drives innovation", language),
    getTranslation("Align innovation efforts with strategic goals", language),
    getTranslation(
      "Empower teams across the organization to innovate",
      language
    ),
    getTranslation(
      "Streamline idea development with agile processes",
      language
    ),
    getTranslation(
      "Track progress and measure the impact of initiatives",
      language
    ),
    getTranslation("Foster engagement and creativity across teams", language),
    getTranslation(
      "Access workshops tailored to solve complex challenges",
      language
    ),
  ];

  const managementOptions = [
    getTranslation("Manual tracking (spreadsheets, documents)", language),
    getTranslation("Using general project management tools", language),
    getTranslation("Team meetings and brainstorming", language),
    getTranslation("Dedicated innovation platform", language),
    getTranslation("No formal process", language),
    getTranslation(
      "Managed by a specific team (e.g., PMO/Transformation)",
      language
    ),
    getTranslation("Employee suggestion programs", language),
  ];

  const onFinish = async (values) => {
    // setLoading(true);
    try {
      const response = await ProjectServices.createEarlyAccess({
        full_name: values.name,
        email: values.email,
        company_name: values.company || "",
        phone_number: values.phone || "", // New field added
        position: values.jobTitle,
        department: values.department,
        industry:
          selectedIndustry === "Other"
            ? values.otherIndustry
            : selectedIndustry,
        company_size: values.companySize,
        budget_holder: isBudgetHolder,
        invite_person: isInviting ? values.invite_person : "", // New field added
        invite_position: isInviting ? values.invite_position : "", // New field added
        invite_email: isInviting ? values.invite_email : "", // New field added
        invite_phone_number: isInviting ? values.invite_phone_number : "", // New field added
        goals: values.goals,
        challenges: values.challenges,
        manage_currently: values.manage_currently || "", // New field added
        using_currently: isUsingTools,
        using_currently_text: isUsingTools ? values.specifiedTools : "", // New field added
        feature_intrest: selectedFeatures.includes("other")
          ? values.otherFeature
          : selectedFeatures.join(", "),
        participation_intrest: values.preferences?.join() || "",
        additional_comment: values.additional_comments || "", // New field added
      });

      message.success(
        getTranslation("Thank you! Your request has been submitted.", language)
      );
      setSubmitted(true);

    } catch (error) {
      console.error("Error sending request: ", error);
      message.error(
        getTranslation(
          "Failed to submit your request. Please try again.",
          language
        )
      );
    } finally {
      setLoading(false);
    }
  };

  const handleIndustryChange = (value) => {
    setSelectedIndustry(value);
    setShowOtherInput(value === "Other");
  };

  const handleDecisionMakerChange = (e) => {
    setIsBudgetHolder(e.target.value === "no");
  };
  const handleInviting = (e) => {
    setIsInviting(e.target.value === "yes");
  };

  const handleRadioChange = (e) => {
    setIsUsingTools(e.target.value === "yes");
  };

  return (
    <div className={styles.bg__primary}>
      <div
        style={{ boxShadow: "0 0.344px 6px gray" }}
        className={styles.contact__form}
      >
        {!submitted ? (
          <>
            <h2>{getTranslation("Join Our Beta Program!", language)}</h2>
            <p>
              {getTranslation(
                "Get early access to the latest features. Please provide your details to get started.",
                language
              )}
            </p>
            <Form layout="vertical" onFinish={onFinish}>
              <Row gutter={16}>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label={getTranslation("Full Name", language)}
                    name="name"
                    rules={[
                      {
                        required: true,
                        message: getTranslation(
                          "Please enter your name",
                          language
                        ),
                      },
                      {
                        pattern: /^[a-zA-Z\s]+$/,
                        message: getTranslation(
                          "Name can only contain letters and spaces",
                          language
                        ),
                      },
                    ]}
                  >
                    <Input
                      placeholder={getTranslation("Your Full Name", language)}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label={getTranslation("Email Address", language)}
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: getTranslation(
                          "Please enter your email",
                          language
                        ),
                      },
                      {
                        type: "email",
                        message: getTranslation(
                          "Please enter a valid email address",
                          language
                        ),
                      },
                    ]}
                  >
                    <Input
                      placeholder={getTranslation(
                        "Your Email Address",
                        language
                      )}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label={getTranslation("Company/Organization", language)}
                    name="company"
                    rules={[
                      {
                        required: true,
                        message: getTranslation(
                          "Please enter Company/Organization name",
                          language
                        ),
                      },
                    ]}
                  >
                    <Input
                      placeholder={getTranslation(
                        "Your Company or Organization",
                        language
                      )}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label={getTranslation("Job Title/Position", language)}
                    name="jobTitle"
                    rules={[
                      {
                        required: true,
                        message: getTranslation(
                          "Please enter your job title",
                          language
                        ),
                      },
                    ]}
                  >
                    <Input
                      placeholder={getTranslation("Your Job Title", language)}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label={getTranslation("Department/Function", language)}
                    name="department"
                    rules={[
                      {
                        required: true,
                        message: getTranslation(
                          "Please enter your department",
                          language
                        ),
                      },
                    ]}
                  >
                    <Input
                      placeholder={getTranslation(
                        "Your Department or Function",
                        language
                      )}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label={getTranslation("Company Size", language)}
                    name="companySize"
                    rules={[
                      {
                        required: true,
                        message: getTranslation(
                          "Please select your company size",
                          language
                        ),
                      },
                    ]}
                  >
                    <Select
                      placeholder={getTranslation(
                        "Select Company Size",
                        language
                      )}
                    >
                      <Option value="1-50">{getTranslation("1–50 employees", language)}</Option>
                      <Option value="51-200">{getTranslation("51–200 employees", language)}</Option>
                      <Option value="201-500">{getTranslation("201–500 employees", language)}</Option>
                      <Option value="501-1000">{getTranslation("501–1,000 employees", language)}</Option>
                      <Option value="1001+">{getTranslation("1,001+ employees", language)}</Option>

                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col xs={24} sm={12} md={showOtherInput ? 8 : 12}>
                  <Form.Item
                    label={getTranslation("Phone Number", language)}
                    name="phone"
                    rules={[
                      {
                        pattern: /^\+?[\d\s\-().]+$/,
                        message: getTranslation(
                          "Please provide a valid phone number",
                          language
                        ),
                      },
                    ]}
                  >
                    <Input
                      placeholder={getTranslation(
                        "e.g., +44 7700 900456",
                        language
                      )}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={showOtherInput ? 8 : 12}>
                  <Form.Item
                    label={getTranslation("Industry Sector", language)}
                    name="industry"
                    rules={[
                      {
                        required: true,
                        message: getTranslation("Please select your industry sector!", language),
                      },
                    ]}
                  >
                    <Select
                      placeholder={getTranslation("Please select your industry sector!", language)}
                      onChange={handleIndustryChange}
                    >
                      <Option value="Healthcare">{getTranslation("Healthcare", language)}</Option>
                      <Option value="Technology">{getTranslation("Technology", language)}</Option>
                      <Option value="Manufacturing">{getTranslation("Manufacturing", language)}</Option>
                      <Option value="Education">{getTranslation("Education", language)}</Option>
                      <Option value="Financial Services">{getTranslation("Financial Services", language)}</Option>
                      <Option value="Government/Public Sector">{getTranslation("Government/Public Sector", language)}</Option>
                      <Option value="Energy and Utilities">{getTranslation("Energy and Utilities", language)}</Option>
                      <Option value="Retail and Consumer Goods">{getTranslation("Retail and Consumer Goods", language)}</Option>
                      <Option value="Transportation and Logistics">{getTranslation("Transportation and Logistics", language)}</Option>
                      <Option value="Other">{getTranslation("Other (Please specify)", language)}</Option>
                    </Select>

                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={showOtherInput ? 8 : 12}>
                  {showOtherInput && (
                    <Form.Item
                      label={getTranslation("Please specify", language)}
                      name="otherIndustry"
                      rules={[
                        {
                          required: true,
                          message: getTranslation("Please specify your industry!", language),
                        },
                      ]}
                    >
                      <Input placeholder={getTranslation("Specify your industry", language)} />
                    </Form.Item>
                  )}
                </Col>
              </Row>

              <Row gutter={16}>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label={getTranslation(
                      "Are you a decision-maker?",
                      language
                    )}
                    name="decisionMaker"
                    rules={[
                      {
                        required: true,
                        message: getTranslation(
                          "Please select an option",
                          language
                        ),
                      },
                    ]}
                  >
                    <Radio.Group onChange={handleDecisionMakerChange}>
                      <Radio value="yes">
                        {getTranslation("Yes", language)}
                      </Radio>
                      <Radio value="no">{getTranslation("No", language)}</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                {isBudgetHolder && (
                  <Col span={24}>
                    <Form.Item
                      label={getTranslation(
                        "Would you like to invite the appropriate person to also receive early access to Compelion?",
                        language
                      )}
                      name="isInviting"
                      rules={[
                        {
                          required: true,
                          message: getTranslation(
                            "Please select an option",
                            language
                          ),
                        },
                      ]}
                    >
                      <Radio.Group onChange={handleInviting}>
                        <Radio value="yes">
                          {getTranslation("Yes", language)}
                        </Radio>
                        <Radio value="no">
                          {getTranslation("No", language)}
                        </Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                )}
              </Row>

              {isInviting && (
                <Row gutter={16}>
                  <Col span={6}>
                    <Form.Item
                      label={getTranslation("Full Name", language)}
                      name="invite_person"
                      rules={[
                        {
                          required: true,
                          message: getTranslation(
                            "Please provide a full name",
                            language
                          ),
                        },
                      ]}
                    >
                      <Input
                        placeholder={getTranslation(
                          "e.g., Sarah Johnson",
                          language
                        )}
                      />
                    </Form.Item>
                  </Col>

                  {/* Job Title/Position */}
                  <Col span={6}>
                    <Form.Item
                      label={getTranslation("Job Title/Position", language)}
                      name="invite_position"
                      rules={[
                        {
                          required: true,
                          message: getTranslation(
                            "Please provide a job title",
                            language
                          ),
                        },
                      ]}
                    >
                      <Input
                        placeholder={getTranslation(
                          "e.g., Chief Innovation Officer",
                          language
                        )}
                      />
                    </Form.Item>
                  </Col>

                  {/* Email Address */}
                  <Col span={6}>
                    <Form.Item
                      label={getTranslation("Email Address", language)}
                      name="invite_email"
                      rules={[
                        {
                          required: true,
                          message: getTranslation(
                            "Please provide an email address",
                            language
                          ),
                        },
                        {
                          type: "email",
                          message: getTranslation(
                            "Please provide a valid email address",
                            language
                          ),
                        },
                      ]}
                    >
                      <Input
                        placeholder={getTranslation(
                          "e.g., sarah.johnson@example.com",
                          language
                        )}
                      />
                    </Form.Item>
                  </Col>

                  {/* Phone Number (Optional) */}
                  <Col span={6}>
                    <Form.Item
                      label={getTranslation("Phone Number", language)}
                      name="invite_phone_number"
                      rules={[
                        {
                          pattern: /^\+?[\d\s\-().]+$/,
                          message: getTranslation(
                            "Please provide a valid phone number",
                            language
                          ),
                        },
                      ]}
                    >
                      <Input
                        placeholder={getTranslation(
                          "e.g., +44 7700 900456",
                          language
                        )}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              )}

              <Form.Item
                label={getTranslation(
                  "What are your primary goals for using Compelion?",
                  language
                )}
                name="goals"
                rules={[
                  {
                    required: true,
                    message: getTranslation(
                      "Please select at least one goal",
                      language
                    ),
                  },
                ]}
              >
                <Checkbox.Group options={goalsOptions} />
              </Form.Item>

              <Form.Item
                label={getTranslation(
                  "What challenges are you facing?",
                  language
                )}
                name="challenges"
                rules={[
                  {
                    required: true,
                    message: getTranslation(
                      "Please enter the challenges you are facing",
                      language
                    ),
                  },
                ]}
              >
                <Input.TextArea
                  placeholder={getTranslation(
                    "e.g. Difficulty in capturing and evaluating ideas effectively",
                    language
                  )}
                />
              </Form.Item>

              <Form.Item
                label={getTranslation(
                  "How do you currently manage ideas and innovation processes?",
                  language
                )}
                name="manage_currently"
                rules={[
                  {
                    required: true,
                    message: getTranslation(
                      "Please select at least one option",
                      language
                    ),
                  },
                ]}
              >
                <Checkbox.Group options={managementOptions} />
              </Form.Item>

              <Row gutter={16} align="middle">
                {/* Are you using any innovation management tools? */}
                <Col span={14}>
                  <Form.Item
                    label={getTranslation(
                      "Are you currently using any innovation management tools or platforms?",
                      language
                    )}
                    name="usingTools"
                    rules={[
                      {
                        required: true,
                        message: getTranslation(
                          "Please select an option",
                          language
                        ),
                      },
                    ]}
                  >
                    <Radio.Group onChange={handleRadioChange}>
                      <Radio value="yes">
                        {getTranslation("Yes", language)}
                      </Radio>
                      <Radio value="no">{getTranslation("No", language)}</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>

                {/* If yes, specify the tools */}
                {isUsingTools && (
                  <Col xs={24} sm={12} md={8}>
                    <Form.Item
                      label={getTranslation(
                        "If yes, please specify:",
                        language
                      )}
                      name="specifiedTools"
                      rules={[
                        {
                          required: true,
                          message: getTranslation(
                            "Please specify the tools",
                            language
                          ),
                        },
                      ]}
                      style={{ marginLeft: "20px" }} // Adjust margin for better spacing beside radio buttons
                    >
                      <Input
                        placeholder={getTranslation(
                          "e.g., IdeaScale, Spigit",
                          language
                        )}
                      />
                    </Form.Item>
                  </Col>
                )}
              </Row>

              <Form.Item
                label={getTranslation(
                  "Which features of Compelion interest you the most? (Select all that apply)",
                  language
                )}
                name="feature_intrest"
              >
                <Checkbox.Group onChange={handleCheckboxChange}>
                  <Checkbox value="ai_alignment">
                    {getTranslation("AI-Driven Strategic Alignment", language)}
                  </Checkbox>
                  <Checkbox value="idea_generation">
                    {getTranslation(
                      "Intelligent Idea Generation and Evaluation",
                      language
                    )}
                  </Checkbox>
                  <Checkbox value="analytics">
                    {getTranslation(
                      "Advanced Analytics and Sentiment Analysis",
                      language
                    )}
                  </Checkbox>
                  <Checkbox value="collaborative_tools">
                    {getTranslation(
                      "Collaborative Tools and AI-Powered Whiteboards",
                      language
                    )}
                  </Checkbox>
                  <Checkbox value="strategic_planning">
                    {getTranslation(
                      "Strategic Planning Frameworks (e.g., Clear Plan)",
                      language
                    )}
                  </Checkbox>
                  <Checkbox value="task_management">
                    {getTranslation(
                      "Automated Task Management and Notifications",
                      language
                    )}
                  </Checkbox>
                  <Checkbox value="other">
                    {getTranslation("Other (Please specify)", language)}
                  </Checkbox>
                </Checkbox.Group>
              </Form.Item>

              {selectedFeatures.includes("other") && (
                <Form.Item
                  label={getTranslation("Please specify:", language)}
                  name="otherFeature"
                  rules={[
                    {
                      required: true,
                      message: getTranslation(
                        "Please specify your other feature",
                        language
                      ),
                    },
                  ]}
                >
                  <Input
                    placeholder={getTranslation(
                      "e.g., Your custom feature",
                      language
                    )}
                  />
                </Form.Item>
              )}

              <Form.Item
                label={getTranslation("Participation Preferences", language)}
                name="preferences"
              >
                <Checkbox.Group>
                  <Checkbox value="user_feedback">
                    {getTranslation("User Feedback Sessions", language)}
                  </Checkbox>
                  <Checkbox value="newsletters">
                    {getTranslation(
                      "Receive Updates and Newsletters",
                      language
                    )}
                  </Checkbox>
                  <Checkbox value="beta_testing">
                    {getTranslation("Beta Testing", language)}
                  </Checkbox>
                  <Checkbox value="webinars">
                    {getTranslation("Webinars and Training Sessions", language)}
                  </Checkbox>
                </Checkbox.Group>
              </Form.Item>

              <Form.Item
                label={getTranslation(
                  "Is there anything else you’d like us to know?",
                  language
                )}
                name="additional_comments"
              >
                <Input.TextArea
                  placeholder={getTranslation(
                    "e.g. We have an upcoming project and are interested in how Compelion can support us.",
                    language
                  )}
                />
              </Form.Item>

              <p>
                <Checkbox
                  style={{ marginRight: "10px" }}
                  onChange={(e) => setIsAccepted(e.target.checked)}
                />
                <small>
                  {getTranslation("I have read and agree to the", language)}{" "}
                  <Link to="/terms-and-conditions">{getTranslation("Terms & Conditions", language)}</Link> {" "}
                  {getTranslation("and", language)}{" "}
                  <Link to="/privacy-policy">{getTranslation("Privacy Policy", language)}</Link>
                </small>
              </p>

              <Form.Item>
                <Button
                  disabled={!isAccepted}
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  block
                >
                  {loading
                    ? getTranslation("Submitting...", language)
                    : getTranslation("Request Early Access", language)}
                </Button>
              </Form.Item>
            </Form>
          </>
        ) : (
          <div style={{ textAlign: "center", padding: 20 }}>
            <div>
              <FiCheckCircle style={{ fontSize: "5rem", color: "#52c41a" }} />
            </div>
            <h2>
              {getTranslation(
                "Thank you for requesting early access!",
                language
              )}
            </h2>
            <p>
              {getTranslation(
                "We will review your request and get back to you soon.",
                language
              )}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default EarlyAccess;
